import UserMessageComponent from "./UserMessageComponent";
import AgentMessageComponent from "./AgentMessageComponent";
import FileUploadStatusComponent from "./FileUploadStatusComponent";

export default function ChatMessageComponent({
  message,
  onApproveSkeleton,
  onUpdateSkeleton,
  onViewDpm,
  currentAnchorId,
  onEditingChange,
  onToggleSidebar,
  onCancelUpload,
  onSelectOption,
  isLoading,
}) {
  if (message.type === "USER_QUERY")
    return <UserMessageComponent message={message} />;
  if (message.type === "AGENT_RESPONSE")
    return (
      <AgentMessageComponent
        message={message}
        onApproveSkeleton={onApproveSkeleton}
        onUpdateSkeleton={onUpdateSkeleton}
        onViewDpm={onViewDpm}
        currentAnchorId={currentAnchorId}
        onEditingChange={onEditingChange}
        onToggleSidebar={onToggleSidebar}
        onSelectOption={onSelectOption}
        isLoading={isLoading}
      />
    );
  const isCancellable =
    message.value?.file_id != null &&
    message.value?.status !== "INGESTION_FAILED" &&
    message.value?.status !== "INGESTION_COMPLETED" &&
    message.value?.status !== "CANCELING" &&
    message.value?.status !== "INGESTION_CANCELING" &&
    message.value?.status !== "FILE_DELETED";
  return (
    <FileUploadStatusComponent
      fileName={message.value?.file_name}
      status={message.value?.status}
      message={message.value?.message}
      progress={message.value?.progress ?? null}
      onCancel={
        isCancellable && onCancelUpload
          ? () =>
              onCancelUpload(message.value?.file_id, message.value?.request_id)
          : undefined
      }
    />
  );
}
